import * as React from 'react'

import apis from '@app/api/api'

import ScreenContainer from '@components/screenContainer/screenContainer'
import PicturesDetailsMenu from '@components/menu/picturesDetailsMenu'
import PicturesDetailsMap from '@components/map/picturesDetailsMap'

interface Props {
  navigation: Navigation
  businessId: string
}

const PicturesDetails = ({ navigation, businessId }: Props) => {
  const [screenStatus, setScreenStatus] = React.useState<ScreenStatus>('loading')

  const [business, setBusiness] = React.useState<BusinessDetails | undefined>(undefined)
  const [declarationFocused, setDeclarationFocused] = React.useState<string | undefined>(undefined)

  const pictures = React.useMemo(
    () =>
      business
        ? business.declarations.reduce((acc, cur) => {
            if (!declarationFocused || declarationFocused === cur.id) {
              acc.push(...cur.pictures)
            }
            return acc
          }, [] as BusinessDeclarationPicture[])
        : [],
    [business, declarationFocused]
  )

  React.useEffect(() => {
    apis.business
      .get(businessId)
      .then((b) => {
        setBusiness(b)
        setScreenStatus('fetched')
      })
      .catch(() => setScreenStatus('error'))
  }, [])

  return (
    <ScreenContainer
      menu={<PicturesDetailsMenu navigation={navigation} screenStatus={screenStatus} pictures={pictures} />}
      content={
        <PicturesDetailsMap
          navigation={navigation}
          screenStatus={screenStatus}
          business={business}
          setDeclarationFocused={setDeclarationFocused}
          declarationFocused={declarationFocused}
        />
      }
    />
  )
}

export default PicturesDetails
